import { render, staticRenderFns } from "./slider.vue?vue&type=template&id=4b3c72cb&scoped=true&"
import script from "./slider.vue?vue&type=script&lang=ts&"
export * from "./slider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3c72cb",
  null
  
)

export default component.exports